import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useCompleteVisit } from "src/hooks/useCompleteVisit";

const CompleteCheckInVisit = () => {
  const { t } = useTranslation();
  const page = "completeCheckIn";
  const { handleGoToMessages, handleGoToPortal } = useCompleteVisit();

  return (
    <Stack gap="32px">
      <Stack gap="8px">
        <Typography variant="h5" fontWeight={700}>
          {t(`${page}.title`)}
        </Typography>
        <Typography>{t(`${page}.subtitle`)}</Typography>
      </Stack>
      <Stack gap="16px">
        <Button onClick={handleGoToPortal}>
          {t(`${page}.buttons.0.label`)}
        </Button>
        <Button variant="secondary" onClick={handleGoToMessages}>
          {t(`${page}.buttons.1.label`)}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CompleteCheckInVisit;
